<template>
  <div class="project-form">
    <el-form label-width="80px" :model="projectForm" :rules="rules" ref="projectForm">
      <el-form-item label="负责人" v-show="userInfo.is_admin">
        <el-select v-model="projectForm.user_id" clearable placeholder="请选择">
          <el-option
            v-for="user in userOptions"
            :key="user.user_id"
            :label="user.username"
            :value="user.user_id"
            :disabled="user.is_admin"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="会议名称" prop="meet_name">
        <el-input v-model="projectForm.meet_name"></el-input>
      </el-form-item>
      <el-form-item label="会议编号" prop="meet_num">
        <el-input v-model="projectForm.meet_num"></el-input>
      </el-form-item>
      <el-form-item label="会议时间" prop="meet_time">
        <el-date-picker
          v-model="projectForm.meet_time"
          type="datetime"
          placeholder="选择会议时间"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="承接单位" prop="company">
        <el-select v-model="projectForm.company" clearable  @focus="loadReceiversOptions" placeholder="请选择">
          <el-option
            v-for="opt in receiverOptions"
            :key="opt"
            :label="opt"
            :value="opt"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="会议地点" prop="meet_addr">
        <el-input v-model="projectForm.meet_addr"></el-input>
      </el-form-item>
      <el-form-item label="出席人数">
        <el-input-number v-model="projectForm.attendance"></el-input-number>
      </el-form-item>
      <el-form-item label="会议描述">
        <el-input
          v-model="projectForm.desc"
          type="textarea"
          autosize
          placeholder="请输入会议描述信息"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button v-if="!projectForm.project_id" type="primary" @click="addProjectInfo"
          >创建</el-button
        >
        <el-button v-else type="primary" @click="editProjectInfo">修改</el-button>
        <el-button @click="$router.go(-1)">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getUserInfo } from "../utils/utils.js";
export default {
  data() {
    return {
      receiverOptions: [],
      userOptions: [],
      projectForm: {
        user_id: null,
        project_id: null,
        meet_name: "",
        meet_num: "",
        meet_time: "",
        company: "",
        meet_addr: "",
        attendance: 0,
        desc: "",
      },
      userInfo: {
        is_admin: false,
        user_id: null,
        username: "",
      },
      rules: {
        meet_name: [{ required: true, message: "请输入会议名称", trigger: "blur" }],
        meet_num: [{ required: true, message: "请输入会议编号", trigger: "blur" }],
        meet_time: [{ required: true, message: "请输入会议时间", trigger: "blur" }],
        company: [{ required: true, message: "请输入承接单位", trigger: "blur" }],
        meet_addr: [{ required: true, message: "请输入会议地点", trigger: "blur" }],
      },
    };
  },
  methods: {
    loadReceiversOptions() {
      let that = this;
      that.$axios
        .get(that.host + "/api/receivers/options")
        .then((res) => {
          that.receiverOptions = res.data.results;
        })
        .catch((err) => {
          that.$message.error(err.data.errmsg);
        });
    },
    editProjectInfo() {
      let that = this;
      that.$axios
        .put(that.host + "/api/projects", that.projectForm)
        .then((res) => {
          that.$message.success("修改成功");
          that.$router.push({
            path: "/statement/projects",
          });
          return;
        })
        .catch((err) => {
          that.$message.error(err.data.errmsg);
          return;
        });
    },
    addProjectInfo() {
      let that = this;
      that.$refs["projectForm"].validate((valid) => {
        if (valid) {
          if (!that.projectForm.user_id) {
            that.projectForm.user_id = that.userInfo.user_id;
          }
          that.$axios
            .post(that.host + "/api/projects", that.projectForm)
            .then((res) => {
              that.$message.success("添加成功");
              that.$router.push({
                path: "/statement/projects",
              });
            })
            .catch((err) => {
              that.$message.error(err.data.errmsg);
            });
        } else {
          that.$message.warning("参数校验失败");
        }
      });
    },
    loadUserOpts() {
      let that = this;
      that.$axios
        .get(that.host + "/api/users/options")
        .then((res) => {
          that.userOptions = res.data.results;
        })
        .catch((err) => {
          that.$message.error(err.data.errmsg);
        });
    },
    loadProjectDetail(project_id) {
      let that = this;
      that.$axios
        .get(that.host + "/api/projects?project_id=" + project_id)
        .then((res) => {
          let results = res.data.results;
          that.projectForm = {
            project_id: results.project_id,
            user_id: results.user.user_id,
            meet_name: results.meet_name,
            meet_num: results.meet_num,
            meet_time: results.meet_time,
            company: results.company,
            meet_addr: results.meet_addr,
            attendance: results.attendance,
            desc: results.desc,
          };
        })
        .catch((err) => {
          that.$message.error(err.data.errmsg);
        });
    },
  },
  mounted() {
    let that = this;
    that.projectForm.meet_num = new Date().Format("yyyyMMddHHmmss");
    let project_id = that.$route.query.project_id;
    if (project_id) {
      that.loadProjectDetail(project_id);
    }
    getUserInfo().then((res) => {
      that.userInfo = res;
      if (that.userInfo.is_admin) {
        that.loadUserOpts();
      }
    });
  },
};
</script>

<style>
.project-form {
  width: 80%;
  padding: 0 30px 0 30px;
}
</style>
